import { Link } from 'react-router-dom';
import { useState } from "react";
import DemoCard from "./DemoCard";
import Weather from "./Weather";
import PuzzleGrid from "./PuzzleGrid";

export default function DemoGrid({
  activeDemo,
  setActiveDemo,
  flippingCard,
  setFlippingCard
}) {

  const [cursor, setCursor] = useState({ x: 0, y: 0 });

  const demos = [
    { id: "Weather Sparkle-Border", item: <Weather id="Weather" location="Denver" />, description: "Display Weather API within a sparkle-bordered Ad to catch the user's eye." },
    { id: "CSS Only Bounce", item: <><div className="bounce" /><div className="bounce2" /><div className="bounce3" /><div className="bounce4" /></>, description: "Style used to move an element from side to side or up/down", link: "https://dev.to/giftintech/how-to-make-a-simple-bounce-animation-with-just-html-and-css-2lae" },
    { id: "Moving Puzzle", item: <PuzzleGrid />, description: "Take an existing image and create a puzzle from it. Users can attempt to move pieces to correct placement.", link: "https://codepen.io/calm/pen/ZYGjJyZ" },
    { id: "Maze Run", item: <Link to="../Maze"><img src={require('../../assets/maze.png')} className="maze" alt="Maze" /></Link>, description: "Used AI to create a JavaScript generated Maze that you can walk through using mouse click or keyboard arrow keys." },
  ];

  function handleMouseMove(e) {
    setCursor({
      x: e.clientX,
      y: e.clientY
    });
  }

  return (
    <div
      className={`demo-grid ${activeDemo ? "grid-background" : ""}`}
      onMouseMove={handleMouseMove}
    >

      {demos.map((demo) => (
        <DemoCard
          key={demo.id}
          demo={demo}
          cursor={cursor}
          activeDemo={activeDemo}
          setActiveDemo={setActiveDemo}
          flippingCard={flippingCard}
          setFlippingCard={setFlippingCard}
        />
      ))}

    </div>
  );
}